import type { SxProps, Theme } from '@mui/material'
import React, { type FC } from 'react'

import { Checkbox, type CheckboxProps } from '../Checkbox'

const checkboxStyle: SxProps<Theme> = { p: 0 }

export const TableCheckbox: FC<CheckboxProps> = (props) => <Checkbox {...props} size="small" sx={checkboxStyle} />
